import { supabase } from './supabaseClient';

// Membership here is the confirmed tournament roster, not club invitations.
export function captainTransferCandidates(enrollment, currentCaptainId) {
  const seen = new Set();
  const candidates = (Array.isArray(enrollment?.members) ? enrollment.members : []).filter((member) => {
    const id = member && typeof member === 'object' && (member.profile_id || member.id);
    if (!id || String(id) === String(currentCaptainId) || seen.has(String(id))) return false;
    seen.add(String(id));
    return true;
  });
  // Older entries can represent their original entrant only through profile_id.
  // Include that existing member without adding a roster slot or changing payer data.
  const ownerId = enrollment?.profile_id;
  if (ownerId && String(ownerId) !== String(currentCaptainId) && !seen.has(String(ownerId))) {
    const profile = [enrollment.owner_profile, enrollment.profile].find((person) => person?.id === ownerId);
    candidates.push({profile_id: ownerId, name: profile?.name || 'Original entrant', surname: profile?.surname, username: profile?.username});
  }
  return candidates;
}

export async function transferTournamentCaptain({ enrollment, newCaptainId, expectedCaptainId, requestId }) {
  const { data, error } = await supabase.rpc('transfer_tournament_captain', {
    p_enrollment_id: enrollment.id,
    p_new_captain_id: newCaptainId,
    p_expected_captain_id: expectedCaptainId,
    p_request_id: requestId,
  });
  if (error) throw error;
  const saved = data?.enrollment;
  if (!saved || saved.id !== enrollment.id || saved.team_captain_id !== newCaptainId || data.captain_id !== newCaptainId || saved.profile_id !== enrollment.profile_id) {
    throw new Error('The captain transfer was not confirmed. Keep this selection and retry to check its status.');
  }
  return saved;
}
